import React from "react";
import { Portal, Segment } from "semantic-ui-react";
import { AnnotationDetail } from "@canvas-panel/core";

const AnnotationDetailPopup = ({ annotation, ...props }) => {
  return annotation ? (
    <Portal {...props}>
      <Segment
        style={{ zIndex: 1000, top: "40%", left: "40%", position: "absolute" }}
      >
        <AnnotationDetail annotation={annotation} {...props} />
      </Segment>
    </Portal>
  ) : null;
};

export default AnnotationDetailPopup;
